import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const CityCTA = ({ cityName }) => {
  return (
    <section className="py-20 lg:py-28 bg-cream" data-testid="city-cta-section">
      <div className="container-tm">
        <div className="bg-gold rounded-3xl p-10 md:p-14 lg:p-16 text-white relative overflow-hidden grain-overlay">
          <div className="absolute -top-20 -right-20 w-[350px] h-[350px] bg-white/15 rounded-full blur-[120px] pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-3 mb-5">
                <Sparkles size={22} strokeWidth={1.6} className="text-white" />
                <span className="text-[11px] uppercase tracking-[0.28em] font-semibold text-white/80">
                  Sans engagement · Étude gratuite
                </span>
              </div>
              <h2 className="font-serif font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
                Voulez-vous tenter l'aventure
                <span className="italic"> TERRE ET MER CONCIERGERIE</span> et gagner de l'argent avec votre logement à {cityName} ?
              </h2>
              <p className="mt-5 font-sans text-base md:text-lg text-white/85 leading-relaxed max-w-xl">
                Contactez un City Manager pour évaluer votre logement. C'est gratuit et sans engagement.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-wrap gap-3 lg:justify-end">
              <Link to="/contact" className="btn-primary bg-ink text-white hover:bg-white hover:text-ink group" data-testid="city-cta-contact">
                Contactez-nous
                <ArrowRight size={14} strokeWidth={2} className="ml-3 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CityCTA;
